<template>
<div>
  <!-- <Inbox  v-if="!isMobile()" />
  <NotAvailableOnMobile v-else /> -->
  <Inbox />
</div>
</template>

<script>
import Inbox from "@/components/demos/Inbox.vue";
import { isMobileMixin } from '@/mixins/isMobileMixin';
import NotAvailableOnMobile from "@/components/misc/NotAvailableOnMobile.vue";

export default {
  name: "InboxPage",
  components: { Inbox, NotAvailableOnMobile },
  mixins: [isMobileMixin],
  metaInfo: {
    title: "Demos",
  },
};
</script>
